
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import axios from "axios";
import { getAuthToken } from '../../utils/token';
import config from '../../config/config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
const MachineModal = ({ show, handleClose, mode, onMaintenance, onBreakdown }) => {
  const isMaintenance = mode === 'maintenance';
  const [machines, setMachines] = useState([]);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    machine_id: '',
    maintenance_date: '',
    days_required: '',
    maintenance_type: '',
    date: '',
    time: '',          
    description: ''
  });
  const resetForm = () => {
    setFormData({
      machine_id: '',
      maintenance_date: '',
      days_required: '',
      maintenance_type: '',
      date: '',
      time: '',          
      description: ''
    });
    setErrors({});
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleMachineChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, machine_id: selectedOption?.value || "" }));
    setErrors((prev) => ({ ...prev, machine_id: "" }));
  };
  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      let res;

      if (isMaintenance) {
        res = await axios.post(
          `${config.API}/supervisor/maintenance`,
          {
            machine_id: formData.machine_id,
            maintenance_date: formData.maintenance_date,
            days_required: formData.days_required,
            maintenance_type: formData.maintenance_type,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success(res.data.message || "Maintenance record saved successfully");
        onMaintenance();
      } else {
        res = await axios.post(
          `${config.API}/supervisor/machinebreakdownwindow`,
          {
            machine_id: formData.machine_id,
            breakdown_date: formData.date,
            breakdown_time: formData.time,    
            description: formData.description,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        toast.success(res.data.message || "Breakdown report submitted successfully");
        onBreakdown();
      }
      resetForm();
      handleClose();
    } catch (err) {
      if (err.response?.status === 422 && err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
      console.error("Error submitting data:", err.response?.data || err.message);
    }
  };
  useEffect(() => {
    fetchMachineList();
  }, []);
  const fetchMachineList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/machine/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMachines(response.data.machines);
    } catch (err) {
      console.error("Error fetching machines:", err.message);
    }
  };
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className='p-5 font_family'>
        <strong className='fs-4'>
          {isMaintenance ? 'Preventive Maintenance Window' : 'Machine Breakdown Window'}
        </strong>
        <Form>
          <Form.Group className="mb-3 mt-4">
            <Row className="align-items-center">
              <Col xs={4} md={3}>
                <strong>Machine</strong>
              </Col>
              <Col xs={8} md={9}>
                <Select
                  name="machine_id"
                  value={machines
                    .map((machine) => ({ value: machine.id, label: machine.name }))
                    .find((item) => item.value === formData.machine_id) || null}
                  onChange={handleMachineChange}
                  options={machines.map((machine) => ({ value: machine.id, label: `${machine.name} (${machine.machine_code})` }))}
                  placeholder="Select Machine"
                  className={errors.machine_id ? "is-invalid" : ""}
                />
                {errors.machine_id && (
                  <div className="text-danger small">{errors.machine_id[0]}</div>
                )}
              </Col>
            </Row>
          </Form.Group>
          {isMaintenance ? (
            <Row className="mb-3 align-items-center">
              <Col md={6}>
                <Row className="align-items-center">
                  <Col xs={5}><strong>Date of Maintenance</strong></Col>
                  <Col xs={7}>
                    <Form.Control
                      type="date"
                      name="maintenance_date"
                      value={formData.maintenance_date}
                      onChange={handleChange}
                      className={`rounded ${errors.maintenance_date ? "is-invalid" : ""}`}
                    />
                    {errors.maintenance_date && (
                      <div className="text-danger small">{errors.maintenance_date[0]}</div>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Row className="align-items-center">
                  <Col xs={5}><strong>Days Required</strong></Col>
                  <Col xs={7}>
                    <Form.Control
                      type="number"
                      name="days_required"
                      value={formData.days_required}
                      onChange={handleChange}
                      className={`rounded ${errors.days_required ? "is-invalid" : ""}`}
                    />
                    {errors.days_required && (
                      <div className="text-danger small">{errors.days_required[0]}</div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Form.Group className="mb-3">
              <Row>
                <Col md={6}>
                   <Form.Label><strong>Date</strong></Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    className={`rounded mb-2 ${errors.date ? "is-invalid" : ""}`}
                  />
                  {errors.breakdown_date && <div className="text-danger small">{errors.breakdown_date[0]}</div>}
                </Col>
 
                <Col md={6}>
                <Form.Label><strong>Time</strong></Form.Label>
                  <Form.Control
                    type="time"
                    name="time"
                    value={formData.time}
                    onChange={handleChange}
                    className="rounded"
                  />
                  {errors.time && <div className="text-danger small">{errors.time[0]}</div>}
                </Col>
              </Row>
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Row className="align-items-start">
              <Col xs={4} md={3}>
                <strong>{isMaintenance ? 'Maintenance Type' : 'Description of Breakdown'}</strong>
              </Col>
              <Col xs={8} md={9}>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name={isMaintenance ? "maintenance_type" : "description"}
                  value={isMaintenance ? formData.maintenance_type : formData.description}
                  onChange={handleChange}
                  className={`rounded ${
                    errors.maintenance_type || errors.description ? "is-invalid" : ""
                  }`}
                />
                {isMaintenance && errors.maintenance_type && (
                  <div className="text-danger small">{errors.maintenance_type[0]}</div>
                )}
                {!isMaintenance && errors.description && (
                  <div className="text-danger small">{errors.description[0]}</div>
                )}
              </Col>
            </Row>
          </Form.Group>

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>Cancel</Button>
        <Button variant="dark" onClick={handleSubmit}>
          {isMaintenance ? 'Save' : 'Submit'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MachineModal;
